// Have a global look and feel for the ChartJS components
import { Chart } from "react-chartjs-2";
import round from "Utils/round";

const shortenLabels = (label) => {
  if (label.length < 12) return label;

  const words = label.split(" ");
  if (words.length < 2) return label;

  let splitIdx = Math.round(words.length / 2);

  let firstHalf = words.slice(0, splitIdx);
  let seondHalf = words.slice(splitIdx);

  return [firstHalf.join(" "), seondHalf.join(" ")];
};

const addCommasToLabels = (tooltipItem, data) => {
  let dataset = data.datasets[tooltipItem.datasetIndex];
  return [dataset.label, dataset.data[tooltipItem.index].toLocaleString()].join(
    " "
  );
};

const addPercentageToLabels = (tooltipItem, data) => {
  let dataset = data.datasets[tooltipItem.datasetIndex];
  return [
    dataset.label,
    `${dataset.figureValues[tooltipItem.index].toLocaleString()} (${
      dataset.data[tooltipItem.index]
    }%)`,
  ].join(" ");
};

Chart.defaults.global.elements.rectangle = {
  backgroundColor: "rgba(119, 136, 153, 1)",
  borderColor: "rgba(119, 136, 153, 1)",
  borderWidth: 0.5,
  hoverBackgroundColor: "rgba(150,182,229,1)",
  hoverBorderColor: "rgba(150,182,229,1)",
};

Chart.defaults.global.tooltips.callbacks.label = (tooltipItem, data) =>
  addCommasToLabels(tooltipItem, data);

Chart.scaleService.updateScaleDefaults("linear", {
  ticks: {
    callback: (tick) => tick.toLocaleString(),
  },
});

Chart.scaleService.updateScaleDefaults("logarithmic", {
  ticks: {
    callback: (tick) => tick.toLocaleString(),
  },
});

module.exports = {
  addCommasToLabels,
  addPercentageToLabels,
  shortenLabels,
};



// WEBPACK FOOTER //
// ./config/chartjs.global.js